export const minlengthOfSerial = 12;
export const maxlengthOfSerial = 20;
export const minMaxlengthOfGatewayPassword = 16;
export const serialRegExp = /^\d+$/;
export const gatewayPasswordRegExp = /^[A-Z0-9]+$/;

/**
 *  Can be used for boiler / gateway serials check.
 */
export function isValidViessmannSerial(serial: string): boolean {
  if (serial?.length) {
    return (
      minlengthOfSerial <= serial.length &&
      serial.length <= maxlengthOfSerial &&
      serialRegExp.test(serial)
    );
  } else {
    return false;
  }
}

/**
 *  Can be used for gateway id check ( well known as gateway backend password ).
 */
export function isValidGatewayId(gatewayId: string): boolean {
  if (gatewayId?.length) {
    return (
      gatewayId.length === minMaxlengthOfGatewayPassword && gatewayPasswordRegExp.test(gatewayId)
    );
  } else {
    return false;
  }
}
